import { SolApiRespPageInfo } from "./api-resp-page-info";

export class SolApiResponse<T> {
  constructor(public _data: T[], public _page: SolApiRespPageInfo) {}
}
